export default __webpack_public_path__ + "static/media/Marshall Island.dd7c5e18.svg";